export const pagesConstants = {
  dashboard: 'dashboard',
  detections: 'detections'
}
